import { LinkButton, Stack, Text, type ImageProps } from "@hopper-ui/components";
import { useMemo, type ReactElement } from "react";

import { useEnvironmentVariables } from "#app/EnvironmentProvider.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Div, Flex } from "@hopper-ui/components";

interface Props {
    icon: ReactElement<Partial<ImageProps>>;
    title: string;
    description?: string;
}

export const ConnectChannel = ({ icon, title, description }: Props) => {
    const { tShared } = useSharedTranslation();
    const { managementAppBaseUrl } = useEnvironmentVariables();

    const personalIntegrationsUrl = useMemo(() => `${managementAppBaseUrl}/profile/integrations`, [managementAppBaseUrl]);

    return (
        <Div
            borderBottom="neutral-weakest"
            padding="inset-md"
        >
            <Flex justifyContent="space-between" gap="inline-md" alignItems="center">
                <Stack gap="inline-sm">
                    <Flex alignItems="center" gap="inline-sm" className="wai-channel-header">
                        {icon}
                        <Text size="xs" fontWeight="body-xs-semibold" color="neutral">
                            {title}
                        </Text>
                    </Flex>
                    {description
                        ? (
                            <Text size="xs" color="neutral-weak">
                                {description}
                            </Text>
                        )
                        : null}
                </Stack>
                <LinkButton
                    size="sm"
                    variant="secondary"
                    flexShrink={0}
                    href={personalIntegrationsUrl}
                    isExternal
                >
                    {tShared("connect")}
                </LinkButton>
            </Flex>
        </Div>
    );
};
